export enum CaseTransferStatus {
  'STATUS_CREATING' = 1,
  'STATUS_PENDING' = 2,
  'STATUS_CONFIRMED' = 3,
  'STATUS_DECLINED' = 4,
  'STATUS_EXTERNAL_TRANSFER_PROPOSAL_FORWARDED' = 5,
  'STATUS_EXTERNAL_TRANSFER_PROPOSAL_CONFIRMED' = 6,
}
